module.exports = __webpack_public_path__ + "img/arrow_right_3.7b58d4be.svg";